const lenguage = "es-ES"
const dateConfig = {
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: true,
}

export { dateConfig }
export { lenguage }
